import { render, staticRenderFns } from "./TabListAdmin.vue?vue&type=template&id=6fb860ae"
import script from "./TabListAdmin.vue?vue&type=script&lang=js"
export * from "./TabListAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports